export function allowAttribute(componentFactory) {
  const wrapper = function($compile, $injector, $parse) {
    const component = componentFactory($compile, $injector, $parse);
    component.restrict = "AE";
    return component;
  };
  wrapper.$inject = ["$compile", "$injector", "$parse"];
  return wrapper;
}
